// Product Grid Column
theme.collectionProduct = (function () {
  function productGrid(e) {
   
    // product Column
    const productColBtnWrapper = document.querySelector(
      ".product-show-col-buttons"
    );
    if(productColBtnWrapper){
        const gridColumnButtons = productColBtnWrapper.querySelectorAll(".gird-column-icon");
        const girColumnWrapper = document.querySelector("#ProductGridContainer");
        const girColumnWrapperClssList = girColumnWrapper.classList;

        let gridClassName = localStorage.getItem("gridColumn");
        if (gridClassName) {
          girColumnWrapper.classList.remove(
            "grid-col-2",
            "grid-col-3",
            "grid-col-4",
            "list"
          );
          girColumnWrapper.classList.add(gridClassName);
        }

        gridColumnButtons.forEach((singleItem) => {
          if (gridClassName) {
            switch (gridClassName) {
              case "grid-col-2":
                if (singleItem.classList.contains("product-col-two")) {
                  singleItem.classList.add("active");
                  getSiblings(singleItem).forEach(function (item) {
                    item.classList.remove("active");
                  });
                }
                break;
              case "grid-col-3":
                if (singleItem.classList.contains("product-col-three")) {
                  singleItem.classList.add("active");
                  getSiblings(singleItem).forEach(function (item) {
                    item.classList.remove("active");
                  });
                }
                break;
              case "list":
                if (singleItem.classList.contains("product-list")) {
                  singleItem.classList.add("active");
                  getSiblings(singleItem).forEach(function (item) {
                    item.classList.remove("active");
                  });
                }
                break;
              default:
                if (singleItem.classList.contains("product-col-four")) {
                  singleItem.classList.add("active");
                  getSiblings(singleItem).forEach(function (item) {
                    item.classList.remove("active");
                  });
                }
            }
          }

          singleItem.addEventListener("click", (event) => {
            singleItem.classList.add("active");
            getSiblings(singleItem).forEach(function (item) {
              item.classList.remove("active");
            });

            if (singleItem.classList.contains("product-col-two")) {
              localStorage.setItem("gridColumn", "grid-col-2");

              gridClassName = localStorage.getItem("gridColumn");
              girColumnWrapper.classList.add(gridClassName);

              if (
                girColumnWrapperClssList.contains("list") ||
                girColumnWrapperClssList.contains("grid-col-4") ||
                girColumnWrapperClssList.contains("grid-col-3") ||
                girColumnWrapperClssList.contains("grid-col-1")
              ) {
                girColumnWrapper.classList.remove(
                  "list",
                  "grid-col-4",
                  "grid-col-3",
                  "grid-col-1"
                );
              }
            } else if (singleItem.classList.contains("product-list")) {
              localStorage.setItem("gridColumn", "list");
              gridClassName = localStorage.getItem("gridColumn");

              girColumnWrapper.classList.add(gridClassName);
              if (
                girColumnWrapperClssList.contains("grid-col-4") ||
                girColumnWrapperClssList.contains("grid-col-3") ||
                girColumnWrapperClssList.contains("grid-col-2") ||
                girColumnWrapperClssList.contains("grid-col-1")
              ) {
                girColumnWrapper.classList.remove(
                  "grid-col-4",
                  "grid-col-3",
                  "grid-col-2",
                  "grid-col-1"
                );
              }
            } else if (singleItem.classList.contains("product-col-three")) {
              localStorage.setItem("gridColumn", "grid-col-3");
              gridClassName = localStorage.getItem("gridColumn");

              girColumnWrapper.classList.add(gridClassName);
              if (
                girColumnWrapperClssList.contains("list") ||
                girColumnWrapperClssList.contains("grid-col-4") ||
                girColumnWrapperClssList.contains("grid-col-2") ||
                girColumnWrapperClssList.contains("grid-col-1")
              ) {
                girColumnWrapper.classList.remove(
                  "list",
                  "grid-col-4",
                  "grid-col-2",
                  "grid-col-1"
                );
              }
            } else if (singleItem.classList.contains("product-col-four")) {
              localStorage.setItem("gridColumn", "grid-col-4");
              gridClassName = localStorage.getItem("gridColumn");
              girColumnWrapper.classList.add(gridClassName);
              if (
                girColumnWrapperClssList.contains("list") ||
                girColumnWrapperClssList.contains("grid-col-3") ||
                girColumnWrapperClssList.contains("grid-col-2") ||
                girColumnWrapperClssList.contains("grid-col-1")
              ) {
                girColumnWrapper.classList.remove(
                  "list",
                  "grid-col-3",
                  "grid-col-2",
                  "grid-col-1"
                );
              }
            }
          });
        });
    }

  }
  return productGrid;
})();
